export const ApiOParams = (axios) => {
  const all = async (module, id) => {
    const result = await axios.get(`/adminer/api/oparams/${module}/`)
    return result.data
  }
  const openFeratel = async () => {
    const result = await axios.get('/api/feratel')
    return result.data
  }

  const save = async (module, id = null, data) => {
    let result
    if (id) {
      result = await axios.post(`/adminer/api/oparams/${module}/${id}`, data)
    } else {
      result = await axios.post(`/adminer/api/oparams/${module}`, data)
    }

    return result.data
  }

  const find = async (module, id) => {
    const result = await axios.get(`/adminer/api/oparams/${module}/${id}`)
    return result.data
  }

  const remove = async (module, id = null, data) => {
    const result = await axios.delete(`/adminer/api/oparams/${module}/${id}`)
    return result.data
  }

  return {
    oParamsFind: find,
    oParamsAll: all,
    oParamsRemove: remove,
    oParamsSave: save,
    openFeratel
  }
}
